import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import { GridCloseIcon } from '@mui/x-data-grid';
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import CircularProgress from '@mui/material/CircularProgress';

import CustomHeader from '../../../components/common/header/CustomHeader';
import Sidebar from '../../../components/common/sidebar/Sidebar';
import ExpenseCard from '../ExpenseCard.js/ExpenseCard';
import OpaqueLoading from '../../../components/common/opaqueLoading/opaqueLoading';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

const Container = styled.div`
  width: 100%;
`;

const DialogContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;
`;

const NotDiv = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 600;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  grid-gap: 16px;
  margin: 20px 25px;
  width: 100%;
  height: 100%;
  align-items: stretch;

  @media (min-width: 1024px) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media (max-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 650px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
`;

const Block = styled.div`
  margin: 2px 0 2px 0;
`;

const Span = styled.span`
  font-size: 14px;
  font-weight: 400;
`;

const OwnerName = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0%;
  color: #0088cc;
`;

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const HistoryExpense = () => {
  const debounceTimer = React.useRef(null);

  const [expenses, setExpenses] = useState([]);
  const [eventTeams1, setEventTeams1] = useState([]);
  const [eventTeams2, setEventTeams2] = useState([]);
  const [selectedYear, setSelectedYear] = useState();
  const [selectedMonth, setSelectedMonth] = useState();
  const [selectedExpenseOwner, setSelectedExpenseOwner] = useState();
  const [selectedEventOwner, setSelectedEventOwner] = useState();
  const [eventTypes, setEventTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchLoading1, setSearchLoading1] = useState(false);
  const [searchLoading2, setSearchLoading2] = useState(false);
  const [user, setUser] = useState({});
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState();

  const [selectedExpense, setSelectedExpense] = useState();
  const [eventType, setEventType] = useState();
  const [eventAmount, setEventAmount] = useState();
  const [approvedAmount, setApprovedAmount] = useState();
  const [remarks, setRemarks] = useState();
  const [date, setDate] = useState();
  const [eventTypeName, setEventTypeName] = useState();
  const [expenseEvents, setExpenseEvents] = useState([]);
  const [expenseEvent, setExpenseEvent] = useState();
  const [expenseEventName, setExpenseEventName] = useState();
  const [expenseSfid, setExpenseSfid] = useState();
  const [openDialog, setOpenDialog] = useState(false);
  const [openDialog2, setOpenDialog2] = useState(false);
  const [imageUrl, setImageUrl] = useState();
  const [errors, setErrors] = useState({});

  const [pageNumber, setPageNumber] = useState(1);
  const [isFetch, setIsFetch] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [spinLoading, setSpinLoading] = useState(false);
  const loaderRef = useRef(null);

  const [auth, setAuth] = useState({});
  const [years, setYears] = useState([]);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('storedUserData'));
    if (user) {
      getEventRecordTypeId();
      getEventTeams1();
      getEventTeams2();
      getStateData();
      setUser(user);
    } else {
      window.location.reload();
    }
  }, []);

  useEffect(() => {
    getYearWindow();
  }, []);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('storedUserData'));
    if (user) {
      setAuth(user);
    }
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !spinLoading && hasMore) {
        setPageNumber((prev) => prev + 1);
      }
    });

    const currentLoader = loaderRef.current;
    if (currentLoader) {
      observer.observe(currentLoader);
    }

    return () => {
      if (currentLoader) observer.unobserve(currentLoader);
    };
  }, [spinLoading, hasMore]);

  useEffect(() => {
    if (pageNumber === 1 && isFetch) {
      return;
    }

    if (!isFetch) {
      approvalExpenseList();
    } else {
      handleSubmit2();
    }
  }, [pageNumber]);

  function getYearWindow(date = new Date()) {
    const current = date.getFullYear();
    setYears([current - 1, current, current + 1]);
    return [current - 1, current, current + 1];
  }

  const getStateData = async () => {
    try {
      const response = await window.Platform.database.getStates();
      setStates(response.data.filter((item) => item.name__c));
    } catch (error) {
      console.error(error);
    }
  };

  const handleYearChange = async (value) => {
    setSelectedYear(value);

    if (!value) {
      setLoading(true);

      const result = await window.Platform.database.approvalExpenseList({
        stateSfid: selectedState?.sfid || '',
        year: value,
        monthName: selectedMonth,
        expenseOwnerSfid: selectedExpenseOwner?.sfid
          ? selectedExpenseOwner?.sfid
          : '',
        eventOwnerSfid: selectedEventOwner?.sfid
          ? selectedEventOwner?.sfid
          : '',
        pageNumber: 1,
      });

      setPageNumber(1);
      setIsFetch(true);
      setHasMore(true);

      if (result?.data?.length < 20) {
        setHasMore(false);
      }

      setExpenses(result.data);
      setLoading(false);
    }
  };

  const handleStateChange = async (value) => {
    setSelectedState(value);
    if (!value) {
      setLoading(true);

      const result = await window.Platform.database.getApprovalExpenseHistory({
        stateSfid: value?.sfid || '',
        year: selectedYear,
        monthName: selectedMonth,
        expenseOwnerSfid: selectedExpenseOwner?.sfid
          ? selectedExpenseOwner?.sfid
          : '',
        eventOwnerSfid: selectedEventOwner?.sfid
          ? selectedEventOwner?.sfid
          : '',
        pageNumber: 1,
      });

      setPageNumber(1);
      setIsFetch(true);
      setHasMore(true);

      if (result?.data?.length < 20) {
        setHasMore(false);
      }

      setExpenses(result.data);
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpenDialog(false);
    setEventType(null);
    setEventAmount(null);
    setDate(null);
    setEventTypeName(null);
    setExpenseEvent(null);
    setImageUrl(null);
  };

  const handleInputChange = (e) => {
    const approvedAmount =
      typeof Number(e.target.value) === 'number' ? +e.target.value : 0;
    if (approvedAmount <= eventAmount) {
      setApprovedAmount(+e.target.value);
    } else {
      return;
    }
  };

  const handleRemarksChange = (e) => {
    setRemarks(e.target.value);
  };

  const getEventRecordTypeId = async () => {
    try {
      setLoading(true);
      const result = await window.Platform.database.getEventRecordTypeId();
      setEventTypes(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getExpenseEventList = async (value) => {
    try {
      const payload = {
        eventType: typeof value === 'object' ? value.value : value,
        searchField: '',
        pageNumber: 1,
      };
      const result = await window.Platform.database.getExpenseEventList(
        payload
      );
      setExpenseEvents(result.data);
      return result.data;
    } catch (error) {
      console.log(error);
    }
  };

  const approvalExpenseList = async (value = null, type = null) => {
    try {
      if (pageNumber === 1) {
        setIsFetch(false);
      } else if (!hasMore || spinLoading) {
        return;
      }

      setSpinLoading(true);
      const result = await window.Platform.database.getApprovalExpenseHistory({
        year: null,
        monthName: '',
        expenseOwnerSfid: type === 'expense owner' ? value : '',
        eventOwnerSfid: type === 'event owner' ? value : '',
        pageNumber,
      });

      if (result.data?.length < 20) {
        setHasMore(false);
      }

      setExpenses((prev) => [...prev, ...result.data]);
      setLoading(false);
      setSpinLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      setSpinLoading(false);
    }
  };

  const getEventTeams1 = async (value = null) => {
    try {
      const result = await window.Platform.database.activityTeams({
        pageNumber: 1,
        searchField: value ? value : '',
      });
      setEventTeams1(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getEventTeams2 = async (value = null) => {
    try {
      const result = await window.Platform.database.activityTeams({
        pageNumber: 1,
        searchField: value ? value : '',
      });
      setEventTeams2(result.data);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleMonthChange = async (value) => {
    setSelectedMonth(value);

    if (!value) {
      setLoading(true);

      const result = await window.Platform.database.getApprovalExpenseHistory({
        stateSfid: selectedState?.sfid || '',
        year: selectedYear,
        monthName: value,
        expenseOwnerSfid: selectedExpenseOwner?.sfid
          ? selectedExpenseOwner?.sfid
          : '',
        eventOwnerSfid: selectedEventOwner?.sfid
          ? selectedEventOwner?.sfid
          : '',
        pageNumber: 1,
      });

      setPageNumber(1);
      setHasMore(true);
      setIsFetch(true);

      if (result?.data?.length < 20) {
        setHasMore(false);
      }

      setExpenses(result.data);
      setLoading(false);
    }
  };

  const handleExpenseOwnerChange = async (value) => {
    setSelectedExpenseOwner(value);

    if (!value) {
      setSearchLoading1(true);

      const result = await window.Platform.database.getApprovalExpenseHistory({
        stateSfid: selectedState?.sfid || '',
        year: selectedYear,
        monthName: selectedMonth,
        expenseOwnerSfid: value,
        eventOwnerSfid: selectedEventOwner?.sfid
          ? selectedEventOwner?.sfid
          : '',
        pageNumber: 1,
      });

      setPageNumber(1);
      setIsFetch(true);
      setHasMore(true);

      if (result?.data?.length < 20) {
        setHasMore(false);
      }

      setExpenses(result.data);
      setSearchLoading1(false);
    }
  };

  const handleEventOwnerChange = async (value) => {
    setSelectedEventOwner(value);

    if (!value) {
      setSearchLoading2(true);

      const result = await window.Platform.database.getApprovalExpenseHistory({
        stateSfid: selectedState?.sfid || '',
        year: selectedYear,
        monthName: selectedMonth,
        expenseOwnerSfid: selectedExpenseOwner?.sfid
          ? selectedExpenseOwner?.sfid
          : '',
        eventOwnerSfid: value,
        pageNumber: 1,
      });

      setPageNumber(1);
      setIsFetch(true);
      setHasMore(true);

      if (result?.data?.length < 20) {
        setHasMore(false);
      }

      setExpenses(result.data);
      setSearchLoading2(false);
    }
  };

  const handleExpenseUpdate = async (expense) => {
    setErrors({});
    setSelectedExpense(expense);
    const eventType = eventTypes?.find(
      (eventType) => eventType.eventName === expense.event_type__c
    );
    setEventType(eventType);
    setEventTypeName(eventType.mainEventName);
    const expenseList = await getExpenseEventList(eventType);
    const expenseEvent = expenseList.find(
      (expenseObj) => expenseObj.eventsfid === expense.eventsfid
    );
    setExpenseEvent(expenseEvent);
    setExpenseEventName(expenseEvent?.eventname);
    setExpenseSfid(expense?.expensesfid);
    setEventAmount(expense?.amount__c);
    setApprovedAmount(expense?.approved_amount__c);
    setRemarks(expense?.remarks);
    setDate(expense?.date__c ? dayjs(expense?.date__c) : null);
    setImageUrl(expense?.upload_file__c);
    setOpenDialog(true);
  };

  const handleSubmit2 = async (isCalled = false) => {
    try {
      // if (isCalled) {
      //   setPageNumber(1);
      //   setIsFetch(true);
      //   setHasMore(true);
      // } else if (!hasMore || spinLoading) {
      //   return;
      // }

      const result = await window.Platform.database.getApprovalExpenseHistory({
        stateSfid: selectedState?.sfid || '',
        year: selectedYear,
        monthName: selectedMonth,
        expenseOwnerSfid: selectedExpenseOwner?.sfid
          ? selectedExpenseOwner?.sfid
          : '',
        eventOwnerSfid: selectedEventOwner?.sfid
          ? selectedEventOwner?.sfid
          : '',
        pageNumber: isCalled ? 1 : pageNumber,
      });

      if (result.data?.length < 20) {
        setHasMore(false);
      }

      if (isCalled) {
        setPageNumber(1);
        setIsFetch(true);
        // setHasMore(true);
      } else if (!hasMore || spinLoading) {
        return;
      }

      if (isCalled) {
        setExpenses(result.data);
      } else {
        setExpenses((prev) => [...prev, ...result.data]);
      }

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const debouncedSearchField = (event, name) => {
    const { value } = event.target;

    if (value.length !== 0) {
      if (value.length <= 3) {
        return;
      }
    }

    clearTimeout(debounceTimer.current);

    if (name === 'Expense Owner') {
      setSearchLoading1(true);
      setEventTeams1([]);
      setSelectedExpenseOwner(value);
    } else {
      setSearchLoading2(true);
      setEventTeams2([]);
      setSelectedEventOwner(value);
    }

    debounceTimer.current = setTimeout(() => {
      const conditionalObject = {
        'Expense Owner': () => getEventTeams1(value, 'expense owner'),
        'Event Owner': () => getEventTeams2(value, 'event owner'),
      };

      conditionalObject[name]();
      setSearchLoading1(false);
      setSearchLoading2(false);
    }, 1500);
  };

  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        backgroundColor: '#F6F6F6',
        minHeight: '100vh',
      }}
    >
      <Sidebar />
      <Container>
        {loading && <OpaqueLoading />}
        <CustomHeader name='expense' />
        <Box
          p={4}
          style={{
            position: 'sticky',
            top: '60px',
            backgroundColor: '#F6F6F6',
            zIndex: 99,
          }}
        >
          <Box
            style={{ width: '100%' }}
            display='flex'
            flexDirection='row'
            flexWrap='wrap'
            alignItems='center'
            justifyContent='flex-end'
            gap='10px'
          >
            <FlexContainer
              style={{ flexWrap: 'wrap', justifyContent: 'flex-end' }}
            >
              <FormControl style={{ width: '180px' }} size='small'>
                <Autocomplete
                  size='small'
                  value={selectedState || null}
                  onChange={(event, newValue) => handleStateChange(newValue)}
                  options={states}
                  getOptionLabel={(option) => option.name__c || ''}
                  isOptionEqualToValue={(option, value) => {
                    if (!value) return false;
                    return option.sfid === value.sfid;
                  }}
                  fullWidth
                  autoComplete='off'
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label='Select State'
                      slotProps={{
                        input: {
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        },
                      }}
                    />
                  )}
                  filterOptions={(options, { inputValue }) => {
                    return options.filter((option) =>
                      option?.name__c
                        ?.toLowerCase()
                        .startsWith(inputValue?.toLowerCase())
                    );
                  }}
                />
              </FormControl>

              <FormControl style={{ width: '180px' }} size='small'>
                <Autocomplete
                  size='small'
                  value={selectedYear || null}
                  onChange={(event, newValue) => handleYearChange(newValue)}
                  options={years}
                  getOptionLabel={(option) => option}
                  isOptionEqualToValue={(option, value) => option === value}
                  fullWidth
                  autoComplete='off'
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label='Select Year'
                      slotProps={{
                        input: {
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        },
                      }}
                    />
                  )}
                  filterOptions={(options, { inputValue }) => {
                    return options.filter((option) =>
                      option
                        ?.toString()
                        ?.toLowerCase()
                        ?.includes(inputValue?.toString()?.toLowerCase())
                    );
                  }}
                />
              </FormControl>

              <FormControl style={{ width: '180px' }} size='small'>
                <Autocomplete
                  size='small'
                  value={selectedMonth || null}
                  onChange={(event, newValue) => handleMonthChange(newValue)}
                  options={months}
                  getOptionLabel={(option) => option}
                  isOptionEqualToValue={(option, value) => option === value}
                  fullWidth
                  autoComplete='off'
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label='Select Month'
                      slotProps={{
                        input: {
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        },
                      }}
                    />
                  )}
                  filterOptions={(options, { inputValue }) => {
                    return options.filter((option) =>
                      option?.toLowerCase().includes(inputValue?.toLowerCase())
                    );
                  }}
                />
              </FormControl>

              <FormControl style={{ width: '180px' }} size='small'>
                <Autocomplete
                  size='small'
                  value={selectedExpenseOwner || null}
                  onChange={(event, newValue) =>
                    handleExpenseOwnerChange(newValue)
                  }
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === 'clear') {
                      getEventTeams1();
                      return;
                    }
                  }}
                  options={eventTeams1}
                  getOptionLabel={(option) =>
                    typeof option === 'string' ? option : option?.name__c || ''
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.name__c === value
                  }
                  fullWidth
                  autoComplete='off'
                  loading={searchLoading1}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label='Expense Owner'
                      onChange={(event) =>
                        debouncedSearchField(event, 'Expense Owner')
                      }
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {searchLoading1 && (
                              <CircularProgress color='inherit' size={20} />
                            )}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                  filterOptions={(options, state) => {
                    return options.filter((option) =>
                      option.name__c?.toLowerCase()
                    );
                  }}
                />
              </FormControl>

              <FormControl style={{ width: '180px' }} size='small'>
                <Autocomplete
                  size='small'
                  value={selectedEventOwner || null}
                  onChange={(event, newValue) =>
                    handleEventOwnerChange(newValue)
                  }
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === 'clear') {
                      getEventTeams2();
                      return;
                    }
                  }}
                  options={eventTeams2}
                  getOptionLabel={(option) =>
                    typeof option === 'string' ? option : option?.name__c || ''
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.name__c === value
                  }
                  fullWidth
                  autoComplete='off'
                  loading={searchLoading2}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label='Event Owner'
                      onChange={(event) =>
                        debouncedSearchField(event, 'Event Owner')
                      }
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {searchLoading2 && (
                              <CircularProgress color='inherit' size={20} />
                            )}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                  filterOptions={(options, state) => {
                    return options.filter((option) =>
                      option.name__c?.toLowerCase()
                    );
                  }}
                />
              </FormControl>

              <Button variant='contained' onClick={() => handleSubmit2(true)}>
                Fetch
              </Button>
            </FlexContainer>
          </Box>
        </Box>

        {expenses.length > 0 ? (
          <Grid container spacing={2} padding={2} pt={0}>
            <GridContainer>
              {expenses.map((expense, index) => {
                return (
                  <ExpenseCard
                    key={index}
                    expense={expense}
                    handleExpenseUpdate={handleExpenseUpdate}
                    type='history'
                    user={user}
                    auth={auth}
                  />
                );
              })}
            </GridContainer>
          </Grid>
        ) : (
          <NotDiv>No Data Found</NotDiv>
        )}

        <Dialog
          open={openDialog}
          onClose={handleClose}
          sx={{
            '& .MuiPaper-root.MuiDialog-paper': {
              borderRadius: '16px',
              padding: '24px',
              boxShadow:
                'rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px',
              width: '600px',
            },
            '& .MuiBackdrop-root': {
              backgroundColor: 'transparent',
              backdropFilter: 'blur(1px)',
            },
          }}
        >
          <DialogTitle>
            <IconButton
              onClick={handleClose}
              style={{ position: 'absolute', top: 8, right: 8 }}
            >
              <GridCloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent style={{ paddingTop: '5px' }}>
            <DialogContainer>
              <FormControl fullWidth>
                <InputLabel id='select-label'>Event Type</InputLabel>
                <Select
                  sx={{ borderRadius: '10px' }}
                  labelId='select-label'
                  label='Event Type'
                  value={eventType}
                  disabled
                  required
                  error={Boolean(errors.eventType)}
                >
                  {eventTypes.map((item) => (
                    <MenuItem name={item.mainEventName} value={item}>
                      {item.mainEventName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth>
                <InputLabel id='select-label'>Event ID</InputLabel>
                <Select
                  sx={{ borderRadius: '10px' }}
                  labelId='select-label'
                  label='Event ID'
                  value={selectedExpense?.eventsfid}
                  disabled
                  InputLabelProps={{
                    shrink: selectedExpense?.eventsfid,
                  }}
                >
                  <MenuItem value={selectedExpense?.eventsfid}>
                    {selectedExpense?.formated_event_name__c}
                  </MenuItem>
                </Select>
              </FormControl>
              <Box>
                <Block>
                  <Span>Event Owner: </Span>
                  <OwnerName>
                    {selectedExpense?.event_owner_name}-
                    {selectedExpense?.territoryname}
                  </OwnerName>
                </Block>
              </Box>
              <TextField
                sx={{ width: '100%', borderRadius: '10px' }}
                id='field-input'
                label={`Event Amount`}
                variant='outlined'
                value={eventAmount}
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                slotProps={{
                  textField: {
                    sx: {
                      borderRadius: '10px',
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '10px',
                      },
                    },
                  },
                }}
              />

              <TextField
                sx={{ width: '100%', borderRadius: '10px' }}
                id='field-input'
                label={`Current Approved Amount`}
                variant='outlined'
                value={approvedAmount}
                onInput={(e) => {
                  // Restrict to numbers only
                  e.target.value = e.target.value.replace(/[^0-9]/g, '');
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={handleInputChange}
                required
                disabled
                error={Boolean(errors.approved_amount__c)}
                slotProps={{
                  textField: {
                    sx: {
                      borderRadius: '10px',
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '10px',
                      },
                    },
                  },
                }}
              />

              {selectedExpense?.profile__c === 'SI' &&
                selectedExpense?.rm_approved_amount__c > 0 && (
                  <TextField
                    sx={{ width: '100%', borderRadius: '10px' }}
                    id='field-input'
                    label={`RM Approved Amount`}
                    variant='outlined'
                    value={selectedExpense?.rm_approved_amount__c}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    slotProps={{
                      textField: {
                        sx: {
                          borderRadius: '10px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        },
                      },
                    }}
                  />
                )}

              {selectedExpense?.profile__c === 'AM' &&
                selectedExpense?.rm_approved_amount__c > 0 && (
                  <TextField
                    sx={{ width: '100%', borderRadius: '10px' }}
                    id='field-input'
                    label={`RM Approved Amount`}
                    variant='outlined'
                    value={selectedExpense?.rm_approved_amount__c}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    slotProps={{
                      textField: {
                        sx: {
                          borderRadius: '10px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        },
                      },
                    }}
                  />
                )}

              {selectedExpense?.profile__c === 'SI' &&
                selectedExpense?.rmm_approved_amount__c > 0 && (
                  <TextField
                    sx={{ width: '100%', borderRadius: '10px' }}
                    id='field-input'
                    label={`RMM Approved Amount`}
                    variant='outlined'
                    value={selectedExpense?.rmm_approved_amount__c}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    slotProps={{
                      textField: {
                        sx: {
                          borderRadius: '10px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        },
                      },
                    }}
                  />
                )}

              {selectedExpense?.profile__c === 'AM' &&
                selectedExpense?.rmm_approved_amount__c > 0 && (
                  <TextField
                    sx={{ width: '100%', borderRadius: '10px' }}
                    id='field-input'
                    label={`RMM Approved Amount`}
                    variant='outlined'
                    value={selectedExpense?.rmm_approved_amount__c}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    slotProps={{
                      textField: {
                        sx: {
                          borderRadius: '10px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        },
                      },
                    }}
                  />
                )}

              {selectedExpense?.profile__c === 'SI' &&
                selectedExpense?.zm_approved_amount__c > 0 && (
                  <TextField
                    sx={{ width: '100%', borderRadius: '10px' }}
                    id='field-input'
                    label={`ZM Approved Amount`}
                    variant='outlined'
                    value={selectedExpense?.zm_approved_amount__c}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    slotProps={{
                      textField: {
                        sx: {
                          borderRadius: '10px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        },
                      },
                    }}
                  />
                )}

              {selectedExpense?.profile__c === 'AM' &&
                selectedExpense?.zm_approved_amount__c > 0 && (
                  <TextField
                    sx={{ width: '100%', borderRadius: '10px' }}
                    id='field-input'
                    label={`ZM Approved Amount`}
                    variant='outlined'
                    value={selectedExpense?.zm_approved_amount__c}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    slotProps={{
                      textField: {
                        sx: {
                          borderRadius: '10px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        },
                      },
                    }}
                  />
                )}

              {selectedExpense?.profile__c === 'RM' &&
                selectedExpense?.zm_approved_amount__c > 0 && (
                  <TextField
                    sx={{ width: '100%', borderRadius: '10px' }}
                    id='field-input'
                    label={`ZM Approved Amount`}
                    variant='outlined'
                    value={selectedExpense?.zm_approved_amount__c}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    slotProps={{
                      textField: {
                        sx: {
                          borderRadius: '10px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        },
                      },
                    }}
                  />
                )}

              {selectedExpense?.profile__c === 'RM' &&
                selectedExpense?.vp_approved_amount__c > 0 && (
                  <TextField
                    sx={{ width: '100%', borderRadius: '10px' }}
                    id='field-input'
                    label={`VP Approved Amount`}
                    variant='outlined'
                    value={selectedExpense?.vp_approved_amount__c}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    slotProps={{
                      textField: {
                        sx: {
                          borderRadius: '10px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        },
                      },
                    }}
                  />
                )}

              {selectedExpense?.profile__c === 'RM' &&
                selectedExpense?.sfdc_level1_approved_amount__c > 0 && (
                  <TextField
                    sx={{ width: '100%', borderRadius: '10px' }}
                    id='field-input'
                    label={`SFDC Level 1 Approved Amount`}
                    variant='outlined'
                    value={selectedExpense?.sfdc_level1_approved_amount__c}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    slotProps={{
                      textField: {
                        sx: {
                          borderRadius: '10px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        },
                      },
                    }}
                  />
                )}

              {selectedExpense?.profile__c === 'RMM' &&
                selectedExpense?.sfdc_level1_approved_amount__c > 0 && (
                  <TextField
                    sx={{ width: '100%', borderRadius: '10px' }}
                    id='field-input'
                    label={`SFDC Level 1 (Amit Joshi) Approved Amount`}
                    variant='outlined'
                    value={selectedExpense?.sfdc_level1_approved_amount__c}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    slotProps={{
                      textField: {
                        sx: {
                          borderRadius: '10px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        },
                      },
                    }}
                  />
                )}

              {selectedExpense?.profile__c === 'ZM' &&
                selectedExpense?.sfdc_level2_approved_amount__c > 0 && (
                  <TextField
                    sx={{ width: '100%', borderRadius: '10px' }}
                    id='field-input'
                    label={`SFDC Level 1 (Sood Sir) Approved Amount`}
                    variant='outlined'
                    value={selectedExpense?.sfdc_level2_approved_amount__c}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    slotProps={{
                      textField: {
                        sx: {
                          borderRadius: '10px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        },
                      },
                    }}
                  />
                )}

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label='Date'
                  value={
                    selectedExpense?.date__c
                      ? dayjs(selectedExpense?.date__c, 'DD-MM-YYYY')
                      : null
                  }
                  format='YYYY-MM-DD'
                  disabled
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      sx: {
                        width: '100%',
                        borderRadius: '10px',
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '10px',
                        },
                      },
                    },
                  }}
                />
              </LocalizationProvider>

              <div style={{ position: 'relative', width: '100%' }}>
                <TextField
                  sx={{ width: '100%', borderRadius: '10px' }}
                  id='field-input-image'
                  variant='outlined'
                  value={
                    !imageUrl || imageUrl === 'undefined' || imageUrl === 'null'
                      ? 'Image is not available'
                      : imageUrl
                  }
                  disabled
                  slotProps={{
                    textField: {
                      sx: {
                        borderRadius: '10px',
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '10px',
                        },
                      },
                    },
                  }}
                />

                <Dialog
                  open={openDialog2}
                  onClose={() => setOpenDialog2(false)}
                  maxWidth='md'
                  fullWidth
                >
                  <DialogTitle>Preview</DialogTitle>
                  <DialogContent dividers>
                    {imageUrl?.toLowerCase().endsWith('.pdf') ? (
                      <iframe
                        src={imageUrl}
                        title='PDF Preview'
                        style={{
                          width: '100%',
                          height: '80vh',
                          border: 'none',
                        }}
                      />
                    ) : (
                      <img
                        src={imageUrl}
                        alt='Preview'
                        style={{
                          maxWidth: '100%',
                          maxHeight: '80vh',
                          display: 'block',
                          margin: '0 auto',
                        }}
                      />
                    )}
                  </DialogContent>
                </Dialog>
              </div>
              <TextField
                sx={{ width: '100%', borderRadius: '10px' }}
                id='field-input'
                label={`Remarks`}
                variant='outlined'
                value={
                  remarks === 'null' || remarks === 'undefined' ? '' : remarks
                }
                InputLabelProps={{
                  shrink: remarks,
                }}
                onChange={handleRemarksChange}
                disabled
                slotProps={{
                  textField: {
                    sx: {
                      borderRadius: '10px',
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '10px',
                      },
                    },
                  },
                }}
              />
            </DialogContainer>
          </DialogContent>
        </Dialog>

        <div ref={loaderRef} style={{ height: '50px' }} />

        {spinLoading && pageNumber > 1 && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              padding: '20px',
            }}
          >
            <CircularProgress />
          </div>
        )}
      </Container>
    </div>
  );
};

export default HistoryExpense;
